export default __webpack_public_path__ + "static/media/catlike_1_row.05b9b7f6.ogv";